import { render, staticRenderFns } from "./SuperadminPartnerDashboard.vue?vue&type=template&id=08a5e182&scoped=true"
import script from "./SuperadminPartnerDashboard.vue?vue&type=script&lang=js"
export * from "./SuperadminPartnerDashboard.vue?vue&type=script&lang=js"
import style0 from "./SuperadminPartnerDashboard.vue?vue&type=style&index=0&id=08a5e182&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5e182",
  null
  
)

export default component.exports